import React, { Component } from "react";
import "../Account.css"
import SignupHeader from "./signup.header";
import SignupFooter from "./signup.footer";
import { Link } from "react-router-dom";
import axios from "axios";


class AdminLogin extends Component {
  state = {
    email: '',
    password: '',
    error: null,
    accessToken: null,
    loading: false, // Added loading state
  }
  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };
  handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({ loading: true, error: null }); // Set loading to true and clear previous errors
    try {
      const response = await axios.post('https://api.geoinfoacademy.com/api/tutor-login/', {
        email: this.state.email,
        password: this.state.password,
      });

      // Store the access token in local storage (or a more secure mechanism)
      const accessToken = response.data['access'];
      const userData = response.data['user'];

      // Store access token
      localStorage.setItem('accessToken', accessToken);

      // Store user data (stringify it first)
      localStorage.setItem('user', JSON.stringify(userData));

      this.setState({ accessToken: accessToken, user: userData }); // Update state if needed

      console.log(response.data);
      // Redirect to the protected area of the application
      console.log('Redirecting to dashboard')
      window.location.href = '/tutor_dashboard';
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        // Parse error response
        let errorMessage = "Login failed. Invalid email or password.";
        if (error.response.data.detail) {
          errorMessage = error.response.data.detail;
        }
        this.setState({ error: errorMessage });
      } else {
        this.setState({ error: "Network error or server unavailable." });
      }
    } finally {
      this.setState({ loading: false }); // Set loading to false after response
    }
  };
  render() {
    return (
      <div className=" account_body ">
        <SignupHeader />
        <h1 className="account_header">Admin Login </h1>
        <p className="account_body"></p>
        <div className="account_form_cover">
          <form className="account_form" onSubmit={this.handleSubmit}>
            <label>Email</label><br />
            <input placeholder="Enter Your Email " type="email" id="email" name="email" value={this.state.username} onChange={this.handleChange} /><br /><br />
            <label htmlFor="password">Password</label><br />
            <input placeholder="Enter Your Password" type="password" id="password" name="password" value={this.state.password} onChange={this.handleChange} /><br /><br />
            <button type="submit" disabled={this.state.loading}>
              {this.state.loading ? "logging in..." : "Submit"}
            </button> <br /><br />
            {this.state.error && <p className="account_error">{this.state.error}</p>}
            <p><Link to="/forgotten_password"><span>Forgotten Password</span></Link></p>
            <p>New to Geo-Academy? <Link to="/Admin_sign_up"><span>Join Us</span></Link></p>
          </form>
        </div>
        <SignupFooter />
      </div>
    )
  }
}

export default AdminLogin